const INITIAL_STATE = {
	tests: [],
	test: [],
	resultado: [],
	question: [],
	questions: [],
	sendText: 'Responder',
	finishText: '<i class="fas fa-flag-checkered mr-2"></i>Finalizar Avaliação',
	errorTest: '',
	errorTestQuestion: '',
	errorTestQuestionSingle: '',
	errorAnswer: '',
	loadquestion: false,
	loadquestionsingle: false,
	ultima: 0,
	time: 0,
	timerActive: 0,
	timer: 0,
	resposta: 0,
	tipo: "",
	respondidas: []
}

const testReducer = (state = INITIAL_STATE, action) => {
	switch(action.type){
		case 'TESTS_FETCH':
			return {
				...state, 
				tests: action.payload
			}
		case 'TEST_FETCH':
			return {
				...state, 
				errorTest: '',
				test: action.payload
			}
		case 'RESULT_FETCH':
			return {
				...state,
				errorTest: '',
				resultado: action.payload
			}
		case 'ERROR_TEST_FETCH':
			return {
				...state, 
				errorTest: action.payload,
				test: []
			}
		case 'LOAD_TEST_QUESTION':
			return {
				...state,
				loadquestion: action.payload
			}
		case 'LOAD_TEST_QUESTION_SINGLE':
			return {
				...state,
				loadquestionsingle: action.payload
			}
		case 'QUESTION_TEST_FETCH':
			return {
				...state,
				errorTestQuestion: '',
				question: action.payload
			}
		case 'SET_RESPOSTA':
			return {
				...state,
				resposta: action.payload
			}
		case 'SET_TIPO':
			return {
				...state,
				tipo: action.payload
			}
		case 'QUESTIONS_TEST_FETCH':
			return {
				...state,
				errorTestQuestion: '',
				questions: action.payload
			}
		case 'QUESTIONS_TEST_ERROR':
			return {
				...state,
				errorTestQuestion: action.payload
			}
		case 'QUESTION_TEST_ERROR':
			return {
				...state,
				errorTestQuestionSingle: action.payload
			}
		case 'ANSWER_TEST_ERROR':
			return {
				...state,
				errorAnswer: action.payload
			}
		case 'SEND_TEST_TEXT_CHANGE':
			return {
				...state,
				sendText: action.payload
			}
		case 'FINISH_TEST_TEXT_CHANGE':
			return {
				...state,
				finishText: action.payload
			}
		case 'SET_ULTIMA':
			return{
				...state,
				ultima: action.payload
			}
		case 'SET_RESPONDIDAS':
			return{
				...state,
				respondidas: action.payload
			}
		case 'SET_TIME':
			return{
				...state,
				time: action.payload
			}
		case 'ACTIVATE_TIMER':
			return{
				...state,
				timerActive: action.payload
			}
		case 'SET_TIMER':
			return{
				...state,
				timer: action.payload
			}
		default:
			return state
	}
}

export default testReducer
